import { createAction, props } from '@ngrx/store';

import { AppMessage } from 'src/app/models/common/appMessage';
import { SnackbarData } from 'src/app/models/snackbar/snackbar.model';


export const setSnackbar = createAction('[Message] Snackbar Set Action', props<{snackbar: SnackbarData}>());
export const setMessage = createAction('[Message] Message Set Action', props<{appMessage: AppMessage}>());
export const resetMessageFlag = createAction('[Message] Message Reset Action');
export const setMessageFlag = createAction('[Message] Message Set Active Action');
export const clearMessage = createAction('[Message] Message Clear MessageService Action', props<{timestamp: string}>());
